import React from 'react';
import { enumHelper } from '../../utils';
import ENUMS from '../../enums/index';

const renderStatusColors = status => {
  switch (status) {
    case 'OPEN':
      return 'text-info';
    case 'CLOSE':
      return 'text-scondary';
    case 'SUSPENDED':
      return 'text-warning';
    case 'STARTED':
      return 'text-info';
    case 'APPROVED':
      return 'text-success';
    default:
      return 'text-muted';
  }
};

export const checkoutsReportReservesColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'تاریخ شروع رزرو',
    dataIndex: 'startAt',
    name: 'startAt',
    isSortable: false,
  },
  {
    title: 'تاریخ پایان رزرو',
    dataIndex: 'endAt',
    name: 'endAt',
    isSortable: false,
  },
  {
    title: 'میزها',
    dataIndex: 'reservedTables',
    render: value =>
      value?.map(
        (ele, index, self) =>
          ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`,
      ),
  },
  {
    title: 'کد رزرو',
    dataIndex: 'trackingNumber',
    name: 'trackingNumber',
    isSortable: false,
  },
  {
    title: 'تعداد افراد',
    dataIndex: 'persons',
    name: 'persons',
    isSortable: false,
  },
  {
    title: 'مبلغ سهم آرسی(تومان)',
    dataIndex: 'rseeStockAmount',
    name: 'rseeStockAmount',
    isSortable: false,
    render: rseeStockAmount => (
      <div>{Number(rseeStockAmount).toLocaleString()}</div>
    ),
  },
  {
    title: 'مبلغ پیش پرداخت رزرو(تومان)',
    dataIndex: 'cafeBasePrice',
    name: 'cafeBasePrice',
    isSortable: false,
    render: baseCost => <div>{Number(baseCost).toLocaleString()}</div>,
  },
  {
    title: 'مبلغ ورودی رزرو(تومان)',
    dataIndex: 'totalEntranceAmount',
    name: 'totalEntranceAmount',
    isSortable: false,
    render: cost => <div>{Number(cost).toLocaleString()}</div>,
  },
  {
    title: 'مبلغ تسویه(تومان)',
    dataIndex: 'sumToBePaidToCafePrice',
    name: 'sumToBePaidToCafePrice',
    isSortable: false,
    render: balance => (
      <div className='direction-ltr'>{Number(balance).toLocaleString()}</div>
    ),
  },
  {
    title: 'وضعیت',
    dataIndex: 'status',
    isSortable: false,
    render: status => (
      <td className={`text-center ${renderStatusColors(status)}`}>
        {enumHelper.convertEnumValueToTitle(
          ENUMS.CAFE_RESERVATION.list,
          status,
        )}
      </td>
    ),
  },
];
